import React from 'react';

import SideBar from "../../containers/SideBar/SideBar.jsx";

import {CommonHeader} from "../../containers/CommonHeader/CommonHeader";
import { ContainerDataLens } from '../../components/Container/ContainerDataLens.jsx';


export const DataLensLayout = ({children}) => {
    return <>
        <CommonHeader chart={true} />
        <SideBar/>
        <ContainerDataLens>
            {children}
        </ContainerDataLens>
    </>
}